

import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../components/styles/Productsec.css";
import { Link } from "react-router-dom";


import p1 from "../assets/SSP/Y3.png";
import p2 from "../assets/SSP/B8.png";
import p3 from "../assets/SSP/p1.png";
import p4 from "../assets/SSP/B9.png";
import p5 from "../assets/SSP/W4.png";
import p6 from "../assets/SSP/PW1.png";
import p7 from "../assets/SSP/FC1.jpeg";
import p8 from "../assets/SSP/TIC1.jpeg";
import p9 from "../assets/SSP/FF1.jpeg";
function ProductSection() {
  const products = [
    {
      title: "Floor Cleaner",
      description: "Effectively removes stains and dirt, leaving your floors spotless and fresh.",
      image: p1,
    },
    {
      title: "Dish Wash",
      description: "Tough on grease, gentle on hands, ensuring sparkling clean dishes",
      image: p2,
    },
    {
      title: "Hand Wash",
      description: "Kills germs while keeping your hands soft and moisturized.",
      image: p3,
    },
    {
      title: "Glass Cleaner",
      description: "Streak-free formula for crystal-clear windows and mirrors.",
      image: p4,
    },
    {
      title: "Liquid Detergent",
      description: "Deep cleans clothes while being gentle on fabrics.",
      image: p5,
    },
    {
      title: "Room Freshner",
      description: "Eliminates odors and fills your space with a refreshing fragrance",
      image: p6,
    },
    {
      title: "Toilet Cleaner",
      description: "Removes tough stains, kills germs, and leaves your toilet sparkling clean.",
      image:p7,
      
    },
    {
      title: "Tiles Cleaner",
      description: "Effectively removes stains, grime, and dirt from tiles, restoring their shine.",
      image:p8,
      
    },
    {
      title: "Fabric Freshener",
      description: "Keeps fabrics smelling fresh and removes unwanted odors.",
      image:p9,
      
    },
  ];
  return (
    <section className="product-section py-5">
      <Container>
        <div className="text-center mb-5">
          <span className="product-subtitle">Premium Products</span>
          <h2 className="product-header">Professional Cleaning & Maintenance</h2>
          <div className="product-title-underline"></div>
          <p className="product-description">
            Discover our innovative housekeeping products designed for superior cleanliness.
          </p>
        </div>
        <Row>
          {products.map((product, index) => (
            <Col lg={4} md={6} sm={6} xs={12} className="mb-4" key={index}>
              <Card className="product-card h-100">
                <div className="product-img-container">
                  <Card.Img variant="top" src={product.image} className="product-img" />
                </div>
                <Card.Body className="bg-secondary">
                  <Card.Title className="product-title">{product.title}</Card.Title>
                  <Card.Text className="product-text">{product.description}</Card.Text>
                </Card.Body>
                <Card.Footer className="bg-secondary border-0 pb-4 text-center">
               
                  <Link to='/product'>
                      <Button variant="primary" className="productpage-read-more-btn">
                     View
                      </Button>
                    </Link>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default ProductSection;
